import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, OnInit
} from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

import { MobileDeviceService } from '@app/services/mobile-device.service';
import { ANIMATIONS, TIME_TO_SLIDE } from '@app/constants/animations.constants';
import { AppFacade } from '@app/app.facade';
import { DomManipulateService } from '@app/modules/core/services/dom-manipulate.service';
import { UserGender } from '@booking/entities/user-gender';
import { PaxFacade } from '@pax/pax.facade';

@Component({
  selector: 'app-pax-celebrate',
  templateUrl: './pax-celebrate.container.html',
  styleUrls: ['./pax-celebrate.container.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PaxCelebrateContainer implements OnInit {

  public animation: string = ANIMATIONS.SLIDE_IN_RIGHT;
  public celebratePaxView: UserGender = null;

  public readonly PAX_CELEBRATE_IMAGES_BASE_PATH: string = 'web/travel/PaxCelebrate';
  public readonly PAX_CELEBRATE_MALE_IMAGE: string = 'celebrate-male.png';
  public readonly PAX_CELEBRATE_FEMALE_IMAGE: string = 'celebrate-female.png';

  constructor(
    private readonly router: Router,
    private readonly appFacade: AppFacade,
    private readonly facade: PaxFacade,
    private readonly domManipulateService: DomManipulateService,
    private readonly mobileDeviceService: MobileDeviceService
  ) {
    const extras = this.router.getCurrentNavigation()?.extras;
    if (extras && extras.state) {
      this.celebratePaxView = extras.state.celebratePaxView;
    }
  }

  ngOnInit(): void {
    this.domManipulateService.setBodyScroll(false);
    this.domManipulateService.setBookingScroll(false);
  }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  get image(): string {
    switch (this.celebratePaxView) {
      case UserGender.Male:
        return this.PAX_CELEBRATE_MALE_IMAGE;
      default:
        return this.PAX_CELEBRATE_FEMALE_IMAGE;
    }
  }

  public celebrateStyles(image: string, isMobile: boolean): { [key: string]: string } {
    const uri = encodeURI(image);
    return {
      'background-image': `url(${uri})`,
      'background-repeat': 'no-repeat',
      'background-size': 'contain',
      'background-position': 'left',
      'background-position-y': isMobile ? '-20px' : 'center',
    };
  }

  public close(): void {
    this.isMobile$.pipe(
      tap(isMobile => {
        this.animation = ANIMATIONS.SLIDE_OUT_RIGHT;
        if (isMobile) {
          setTimeout(() => this.appFacade.navigateToLastRoute(), TIME_TO_SLIDE);
        } else {
          this.appFacade.navigateToLastRoute();
        }
        this.domManipulateService.setBodyScroll(true);
        this.domManipulateService.setBookingScroll(true);
        this.facade.setIsActiveCelebratePaxView(null);
      })
    ).subscribe().unsubscribe();

  }

}
